import React from "react";
import PropTypes from "prop-types";
import { useFormik } from "formik";
import TextInput from "~/assets/js/components/Forms/TextInput";
import i18n from "~/assets/js/Helpers/i18n";
import Checkbox from "~/assets/js/components/Forms/Checkbox";
import Button from "~/assets/js/components/Button";
import { isEmail, isRequired } from "~/assets/js/Helpers/validators";
import Headline from "~/assets/js/components/Typography/Headline";

const validate = (values) => {
    const errors = {};

    if (isRequired(values.email)) {
        errors.email = i18n.t("form.errors.required");
    } else if (isEmail(values.email)) {
        errors.email = i18n.t("form.errors.email");
    }

    if (isRequired(values.password)) {
        errors.password = i18n.t("form.errors.required");
    }

    return errors;
};

const LoginForm = ({ changeView, onSubmit, isLoading }) => {
    const formik = useFormik({
        initialValues: {
            email: "",
            password: "",
            staySigned: false,
        },
        onSubmit: ({ email, password, staySigned }) =>
            onSubmit({ email, password, staySigned }),
        validate,
    });

    return (
        <>
            <Headline size={5} resizable>
                {i18n.t("login.title")}
            </Headline>
            <form id="login-form" onSubmit={formik.handleSubmit}>
                <TextInput
                    type="email"
                    bindName="email"
                    value={formik.values.email}
                    error={formik.touched.email && !!formik.errors.email}
                    errorMessage={formik.errors.email}
                    label={i18n.t("form.label.email")}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                />
                <TextInput
                    type="password"
                    bindName="password"
                    value={formik.values.password}
                    error={formik.touched.password && !!formik.errors.password}
                    errorMessage={formik.errors.password}
                    label={i18n.t("form.label.password")}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                />
                <Checkbox
                    bindName="staySigned"
                    value={formik.values.staySigned}
                    onChange={formik.handleChange}
                    label={i18n.t("login.staySigned")}
                />
                <Button
                    type="submit"
                    label={i18n.t("login.submit")}
                    loading={isLoading}
                    size="SM"
                />
            </form>
            {changeView && (
                <div id="forgot-password">
                    <span onClick={changeView}>
                        {i18n.t("login.forgotPassword")}
                    </span>
                </div>
            )}
        </>
    );
};

LoginForm.propTypes = {
    changeView: PropTypes.func,
    onSubmit: PropTypes.func,
    isLoading: PropTypes.bool,
};

export default LoginForm;
